var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-screen",class:{ dark: _vm.isDarkMode },attrs:{"id":"app"}},[_c('nav'),(!_vm.loading)?_c('div',{staticClass:"h-full"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1):_c('div',[_c('div',{staticClass:"espera"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }